import { useEffect } from 'react';

import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';

import awsconfig from './aws-exports';
import { Auth } from './helpers/amplifyAuthCompat';
import { persistor, store } from './redux/store/store';
import { AppRouter } from './router/AppRouter';

export const TalentoTiApp = () => {
	useEffect(() => {
		Auth.configure(awsconfig);
	}, []);

	return (
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistor}>
				<AppRouter />
			</PersistGate>
		</Provider>
	);
};
